import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { AddressGouvFeaturesPropertiesFormDto } from '../../../../services/dtos/form/address-gouv-features-properties-form.dto';
import AddressMovingInForm from '../../../forms/moving-in/moving-in-step-one/address-moving-in.form';
import { AddressMoveInDto } from '../../../../services/dtos/address-move-in.dto';

/**
 * Page de rattachement de contrat
 * @constructor
 */
export default function MovingInStepOneUi(props: {
    handleSearchAddress: (event: object, value: string, reason: string) => void;
    handleChangeShowManualAddress: () => void;
    addressesGouv: AddressGouvFeaturesPropertiesFormDto[];
    showManualAddress: boolean;
    validFormAddress: boolean;
    handleSumbitFormAddress: (values: any) => void;
    addresses?: AddressMoveInDto[];
    handleGoStepTwo: (address: AddressMoveInDto) => void;
}) {
    //Cell du tableau
    // Numéro, Adresse, Ville, Code postal
    const headCells = [
        {
            id: 'numero',
            label: 'Numéro',
            sort: false,
        },
        {
            id: 'address',
            label: 'Adresse',
            sort: false,
        },
        {
            id: 'city',
            label: 'Ville',
            sort: false,
        },
        {
            id: 'postalCode',
            label: 'Code postal',
            sort: false,
        },
        {
            id: 'compteur',
            label: 'N° compteur',
            sort: false,
        },
        {
            id: 'indexDerniereReleveReelle',
            label: 'Dernier index',
            sort: false,
        },
        {
            id: 'dateDerniereReleveReelle',
            label: 'Date dernier index',
            sort: false,
        },
    ];
    return (
        //Début de la page
        <>
            {/*Titre*/}
            <Typography variant="h4">J'emménage</Typography>
            <Paper sx={{ padding: '20px' }}>
                {/*texte*/}
                <Typography variant="body1">
                    Pour souscrire votre nouveau contrat au moment de votre emménagement, vérifiez au préalable que nous{' '}
                    desservons bien votre nouvelle adresse.{' '}
                </Typography>
                <Typography variant="body1">Saisissez ci-dessous l'adresse de votre lieu d'emménagement.</Typography>
                {/*Formulaire*/}
                <AddressMovingInForm
                    handleSearchAddress={props.handleSearchAddress}
                    handleChangeShowManualAddress={props.handleChangeShowManualAddress}
                    addresses={props.addressesGouv}
                    showManualAddress={props.showManualAddress}
                    validFormAddress={props.validFormAddress}
                    handleSumbitFormAddress={props.handleSumbitFormAddress}
                />
                {/*Après la recherche on affiche les données*/}
                {props.addresses &&
                    // Si au moins une donnée alors on affiche un tableau
                    (props.addresses.length > 0 ? (
                        <>
                            {/*texte*/}
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Un ou Plusieurs résultats correspondent à votre recherche
                            </Typography>
                            {/*texte 2*/}
                            <Typography variant="body1">
                                Veuillez sélectionner la ligne correspondant à votre compteur d'eau
                            </Typography>
                            <TableContainer component={Box}>
                                {/* Affichage du tableau*/}
                                <Table>
                                    {/*header*/}
                                    <TableHead>
                                        {/*ligne*/}
                                        <TableRow>
                                            {/*En-têtes*/}
                                            {headCells.map(headCell => (
                                                <TableCell
                                                    key={headCell.id}
                                                    align={'left'}
                                                    sx={{ fontWeight: 'bold', fontSize: 'medium' }}
                                                >
                                                    {headCell.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    {/* Gestion du chargement des pages/tri avec une progress bar */}
                                    <TableBody>
                                        {/*Lignes du tableau*/}
                                        {props.addresses.map((row: AddressMoveInDto) => (
                                            // ligne
                                            <TableRow
                                                hover
                                                sx={{ cursor: 'pointer' }}
                                                key={row.pdiId}
                                                onClick={() => {
                                                    props.handleGoStepTwo(row);
                                                }}
                                                data-testid={'row-' + row.pdiId}
                                            >
                                                {/*numéro rue*/}
                                                <TableCell key={row.numeroRue}>
                                                    {row.numeroRue} {row.complementNumeroRue}
                                                </TableCell>
                                                {/*nom rue*/}
                                                <TableCell key={row.rue}>{row.rue}</TableCell>
                                                {/*ville*/}
                                                <TableCell key={row.ville}>{row.ville}</TableCell>
                                                {/*code postal*/}
                                                <TableCell key={row.codePostal}>{row.codePostal}</TableCell>
                                                {/*Numéro compteur*/}
                                                <TableCell key={row.compteur}>{row.compteur}</TableCell>
                                                {/*Dernier index*/}
                                                <TableCell key={row.indexDerniereReleveReelle}>
                                                    {row.indexDerniereReleveReelle}
                                                </TableCell>
                                                {/*date dernier index*/}
                                                <TableCell key={row.dateDerniereReleveReelle}>
                                                    {row.dateDerniereReleveReelle}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        // Sinon un message disant qu'aucune donnée n'est trouvé
                        <Typography variant="body1" sx={{ display: 'flex', justifyContent: 'center' }}>
                            Aucune adresse trouvée dans notre registre
                        </Typography>
                    ))}
            </Paper>
        </>
    );
}
